import { _copyRange } from './../utils';
export class _DecompressedOutput {
    constructor() {
        this._end = 0;
        this._usedBytes = 0;
        this._dOutput = Array(_DecompressedOutput._dOutSize).fill(0);
        this._end = 0;
        this._usedBytes = 0;
    }
    get _unusedBytes() {
        return _DecompressedOutput._dOutSize - this._usedBytes;
    }
    _write(b) {
        this._dOutput[this._end++] = b;
        this._end &= _DecompressedOutput._dOutMask;
        ++this._usedBytes;
    }
    _writeLD(length, distance) {
        this._usedBytes += length;
        let copyStart = (this._end - distance) & _DecompressedOutput._dOutMask;
        const border = _DecompressedOutput._dOutSize - length;
        if (copyStart <= border && this._end < border) {
            if (length <= distance) {
                _copyRange(this._dOutput, this._end, this._dOutput, copyStart, copyStart + length);
                this._end += length;
            }
            else {
                while (length-- > 0) {
                    this._dOutput[this._end++] = this._dOutput[copyStart++];
                }
            }
        }
        else {
            while (length-- > 0) {
                this._dOutput[this._end++] = this._dOutput[copyStart++];
                this._end &= _DecompressedOutput._dOutMask;
                copyStart &= _DecompressedOutput._dOutMask;
            }
        }
    }
    _copyFrom(input, length) {
        length = Math.min(Math.min(length, _DecompressedOutput._dOutSize - this._usedBytes), input._bytes);
        let copied;
        const tailLen = _DecompressedOutput._dOutSize - this._end;
        if (length > tailLen) {
            copied = input._copyTo(this._dOutput, this._end, tailLen);
            if (copied === tailLen) {
                copied += input._copyTo(this._dOutput, 0, length - tailLen);
            }
        }
        else {
            copied = input._copyTo(this._dOutput, this._end, length);
        }
        this._end = (this._end + copied) & _DecompressedOutput._dOutMask;
        this._usedBytes += copied;
        return copied;
    }
    _copyTo(output, offset, length) {
        let end;
        if (length > this._usedBytes) {
            end = this._end;
            length = this._usedBytes;
        }
        else {
            end = (this._end - this._usedBytes + length) & _DecompressedOutput._dOutMask;
        }
        const copied = length;
        const tailLen = length - end;
        let sourceStart = _DecompressedOutput._dOutSize - tailLen;
        if (tailLen > 0) {
            for (let i = 0; i < tailLen && i + sourceStart < this._dOutput.length && i + offset < output.length; i++) {
                output[offset + i] = this._dOutput[sourceStart + i];
            }
            const sourceStartIndex = _DecompressedOutput._dOutSize - tailLen;
            _copyRange(output, offset, this._dOutput, sourceStartIndex, sourceStartIndex + tailLen);
            offset += tailLen;
            length = end;
        }
        sourceStart = end - length;
        const sourceStartIndex = end - length;
        _copyRange(output, offset, this._dOutput, sourceStartIndex, end);
        this._usedBytes -= copied;
        return { 'count': copied, 'data': output };
    }
}
_DecompressedOutput._dOutSize = 32768;
_DecompressedOutput._dOutMask = 32767;
